<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9" cy="13" r="1" fill="#2B303A"/>
    <path
      d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
      stroke="#2B303A"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M7 6.5C7 5 8 4.5 9 4.5C10 4.5 11 5 11 6.5M11 6.5C11 6.9 11 6.33333 11 6.5ZM11 6.5C11 7.5 10.5 8 10 8.5C9.78121 8.71879 9 9 9 10" stroke="#2B303A" stroke-width="1.6" stroke-linecap="round"/>
  </svg>
</template>

<script setup>
</script>
